// class CollapsibleTab extends HTMLElement {
//     constructor() {
//         super()
//     }
//     // connectedCallback() {
//     //     this.current_width = window.innerWidth, this.description = this.querySelector(".collapsible-tab--content"), this.description_wrapper = this.querySelector(".collapsible-tab--content-wrapper"), this.toggle = this.querySelector(".collapsible-tab--toggle"), this.toggleListener(), this.transitionListener(), this.resizeListener()
//     // }
//     // disconnectedCallback() {
//     //     this.toggle.off("click keydown")
//     // }
//     // toggleListener() {
//     //     this.toggle.on("click keydown", t => {
//     //         "keydown" === t.type && "Enter" !== t.key || (t = "true" === this.toggle.getAttribute("aria-expanded"), this.setTransitions(!t))
//     //     })
//     // }
//     // setTransitions(t) {
//     //     this.toggle.setAttribute("aria-expanded", t), t ? (this.description_wrapper.style.height = this.description.offsetHeight + "px", this.description_wrapper.setState("forwards")) : (this.description_wrapper.style.height = "0px", this.description.setAttribute("data-transition", "fade-out"))
//     // }
//     // resizeListener() {
//     //     window.on("resize", () => {
//     //         this.current_width !== window.innerWidth && (this.setTransitions(!1), this.current_width = window.innerWidth)
//     //     })
//     // }
//     // transitionListener() {
//     //     this.description_wrapper.on("transition:at_end", () => {
//     //         this.description.setAttribute("data-transition", "fade-in")
//     //     })
//     // }
// }
// customElements.define("collapsible-tab-root", CollapsibleTab);


// $('.collapsible-tab--toggle').click(function(){
//         $(this).closest(".collapsible-tab").addClass('active').siblings().removeClass('active');
//         $('.collapsible-tab--content').slideUp();
//         $(this).closest(".collapsible-tab--wrapper").find('.collapsible-tab--content').slideToggle();
//         $(this).closest('.collapsible-tab--wrapper').find().data('fade-out', 'fade-in');
// })



var acc = document.getElementsByClassName("collapsible-tab--toggle");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

// $('.collapsible-tab--wrapper').on('click', '.collapsible-tab--toggle', function() {
//     $('.collapsible-tab--content').slideUp().removeClass('flipInX');
//     //$('.collapsible-tab--wrapper').removeClass('fa-minus');
//     if($(this).next().is(':hidden')) {
//       $(this).next().slideDown().addClass('flipInX');
//       $(this).closest('.collapsible-tab--wrapper').find().data('fade-out', 'fade-in');
//       //$(this).find('.accordion__button').addClass('fa-minus');
//     } else {
//       $(this).next().slideUp();
//       //$(this).find('.accordion__button').addClass('fa-plus');
//     }
//   });